import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import toast from "react-hot-toast";
import { BsTrash } from "react-icons/bs";
import { RiCloseFill } from "react-icons/ri";
import { get, post } from "../../utility/fetchMedical";
import { put } from "../../utility/fetch";
// import { get as gets } from "../../utility/fetchLab";
import debounce from "lodash.debounce"; // Import debounce from lodash

function UpdateModalToAccount({
  closeModal,
  visit,
  id,
  fetchData,
  createTreatment,
  data,
  repeatedDiagnosis,
  setRepeatedDiagnosis,
}) {
  const [carePlan, setCarePlan] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [medications, setMedications] = useState([]);
  const [otherMedications, setOtherMedications] = useState([]);
  const [newOtherMedication, setNewOtherMedication] = useState("");
  const [loading, setLoading] = useState(false);
  const [treatmentCategories, setTreatmentCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(1);
  const [admissionStatus, setAdmissionStatus] = useState("Not To Be Admitted");
  const [selectedMedication, setSelectedMedication] = useState(null); // State for React Select
  const [medicationOptions, setMedicationOptions] = useState([]); // State for fetched medication options
  const [hmo, setHmo] = useState(null);
  const [sugesstPayload, setSuggPayload] = useState({ medications: [] });
  // Store comments for each medication row
  const [medicationComments, setMedicationComments] = useState([]);

  const routesOfAdministration = [
    { id: 1, name: "Orally" },
    { id: 2, name: "Sublingual" },
    { id: 3, name: "Topical" },
    { id: 4, name: "Inhalation" },
    { id: 5, name: "Suppository" },
    { id: 6, name: "IV" },
    { id: 7, name: "IM" },
    { id: 8, name: "Subcut" },
    { id: 9, name: "Intradermal" },
    { id: 10, name: "PerRectum" },
    { id: 11, name: "PerVagina" },
    { id: 12, name: "Implant" },
    { id: 13, name: "Otic" },
    { id: 14, name: "Intranasal" },
  ];

  // const administrationFrequencies = [
  //   { id: 1, name: "Immediately" },
  //   { id: 2, name: "As needed" },
  //   { id: 3, name: "Once daily" },
  //   { id: 4, name: "Twice a day" },
  //   { id: 5, name: "Three times a day" },
  //   { id: 6, name: "Four times a day" },
  //   { id: 7, name: "At night" },
  //   { id: 8, name: "Morning" },
  //   { id: 9, name: "Evening" },
  //   { id: 10, name: "Every 24 hours" },
  //   { id: 11, name: "Every 12 hours" },
  //   { id: 12, name: "Every 8 hours" },
  //   { id: 13, name: "Every 6 hours" },
  //   { id: 14, name: "Every 4 hours" },
  //   { id: 15, name: "Every 3 hours" },
  //   { id: 16, name: "Every 2 hours" },
  //   { id: 17, name: "Every hour" },
  //   { id: 18, name: "Every 2 months" },
  //   { id: 19, name: "Every 3 months" },
  //   // Every 3 months
  // ];
  const administrationFrequencies = [
    { id: 1, name: "Immediately", abbreviation: "STAT" },
    { id: 2, name: "As needed", abbreviation: "PRN" },
    { id: 3, name: "Once daily", abbreviation: "QD / SID" }, // QD often discouraged, SID clearer
    { id: 4, name: "Twice a day", abbreviation: "BID" },
    { id: 5, name: "Three times a day", abbreviation: "TID" },
    { id: 6, name: "Four times a day", abbreviation: "QID" },
    { id: 7, name: "At night", abbreviation: "HS / noct." },
    { id: 8, name: "Morning", abbreviation: "AM" },
    { id: 9, name: "Evening", abbreviation: "PM" },
    { id: 10, name: "Every 24 hours", abbreviation: "Q24H" },
    { id: 11, name: "Every 12 hours", abbreviation: "Q12H" },
    { id: 12, name: "Every 8 hours", abbreviation: "Q8H" },
    { id: 13, name: "Every 6 hours", abbreviation: "Q6H" },
    { id: 14, name: "Every 4 hours", abbreviation: "Q4H" },
    { id: 15, name: "Every 3 hours", abbreviation: "Q3H" },
    { id: 16, name: "Every 2 hours", abbreviation: "Q2H" },
    { id: 17, name: "Every hour", abbreviation: "Q1H" },
    { id: 18, name: "Every 2 months", abbreviation: "q2mo" }, // Common shorthand, not a strict Latin abbr.
    { id: 19, name: "Every 3 months", abbreviation: "q3mo" }, // Common shorthand, not a strict Latin abbr.
  ];

  console.log(visit);

  const fetchTreatmentCategory = async () => {
    try {
      const response = await get("/patients/get-all-categories");
      setTreatmentCategories(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log(data);
    setDiagnosis(repeatedDiagnosis);
    console.log(repeatedDiagnosis);

    // Prepopulate medications from prescription data
    if (data?.prescriptions && Array.isArray(data.prescriptions)) {
      const prescriptionMedications = data.prescriptions.map((prescription) => {
        const doc = prescription.doctorPrescription || {};
        return {
          id: prescription.id,
          name:
            prescription.pharmacyInventory?.productName || "Unknown Medication",
          pharmacyInventoryId: prescription.pharmacyInventory?.id || 0,
          strength: doc.strength || prescription.strength || "",
          drugStrengthUnit:
            doc.drugStrengthUnit !== undefined && doc.drugStrengthUnit !== ""
              ? Number(doc.drugStrengthUnit)
              : prescription.drugStrengthUnit !== undefined &&
                prescription.drugStrengthUnit !== ""
              ? Number(prescription.drugStrengthUnit)
              : "",
          quantity: doc.quantity || prescription.quantity || "",
          frequency: doc.strength || prescription.strength || "",
          administrationFrequency:
            doc.administrationFrequency !== undefined &&
            doc.administrationFrequency !== ""
              ? Number(doc.administrationFrequency)
              : prescription.administrationFrequency !== undefined &&
                prescription.administrationFrequency !== ""
              ? Number(prescription.administrationFrequency)
              : "",
          routeOfAdministration:
            doc.routeOfAdministration !== undefined &&
            doc.routeOfAdministration !== ""
              ? Number(doc.routeOfAdministration)
              : prescription.routeOfAdministration !== undefined &&
                prescription.routeOfAdministration !== ""
              ? Number(prescription.routeOfAdministration)
              : "",
          duration: doc.duration || prescription.duration || "",
          dosage: doc.dosage || prescription.dosage || "",
          comment: prescription.comment || "",
          totalToDispense: prescription.totalToDispense || "",
          pharmacistNote: prescription.pharmacistNote || "",
          isDispensed: prescription.isDispensed || false,
          dispensedDate: prescription.dispensedDate || null,
          dispensedBy: prescription.dispensedBy || null,
          treatmentId: prescription.treatmentId || 0,
        };
      });

      setMedications(prescriptionMedications);
      console.log(
        "Prepopulated medications from prescription:",
        prescriptionMedications
      );
    }
  }, [repeatedDiagnosis, data]);

  // const drugMeasurementUnits = [
  //   { id: 1, name: "Milligrams", symbol: "mg" },
  //   { id: 2, name: "Grams", symbol: "g" },
  //   { id: 3, name: "Micrograms", symbol: "µg" },
  //   { id: 4, name: "Milliliters", symbol: "mL" },
  //   { id: 5, name: "Liters", symbol: "L" },
  //   { id: 6, name: "Units", symbol: "U" },
  //   { id: 7, name: "Puffs" },
  //   { id: 8, name: "Sprays" },
  //   { id: 9, name: "Drops" },
  //   { id: 10, name: "Patch" },
  //   { id: 11, name: "Bottle" },
  //   { id: 12, name: "Transdermal System" },
  //   { id: 13, name: "Tablet" },
  //   { id: 14, name: "Capsule" },
  //   { id: 15, name: "Suppository" },
  //   { id: 16, name: "Scoop" },
  //   { id: 17, name: "Sachet" },
  //   { id: 18, name: "Ampoule" },
  //   { id: 19, name: "Vial" },
  //   { id: 20, name: "Injection Pen" },
  //   { id: 21, name: "Enema" },
  //   { id: 22, name: "Ounces", symbol: "oz" },
  //   { id: 23, name: "Teaspoon", symbol: "tsp" },
  //   { id: 24, name: "Tablespoon", symbol: "tbsp" },
  //   { id: 25, name: "Milliequivalents", symbol: "mEq" },
  //   { id: 26, name: "International Units", symbol: "IU" },
  // ];
  const drugMeasurementUnits = [
    { id: 18, name: "Ampoule", symbol: "amp" },
    { id: 11, name: "Bottle", symbol: "btl" },
    { id: 14, name: "Capsule", symbol: "cap" },
    { id: 9, name: "Drops", symbol: "gtt" }, // or "drop" / "drops"
    { id: 21, name: "Enema", symbol: "enema" },
    { id: 2, name: "Grams", symbol: "g" },
    { id: 26, name: "International Units", symbol: "IU" },
    { id: 20, name: "Injection Pen", symbol: "pen" },
    { id: 5, name: "Liters", symbol: "L" },
    { id: 3, name: "Micrograms", symbol: "µg" },
    { id: 1, name: "Milligrams", symbol: "mg" },
    { id: 25, name: "Milliequivalents", symbol: "mEq" },
    { id: 4, name: "Milliliters", symbol: "mL" },
    { id: 22, name: "Ounces", symbol: "oz" },
    { id: 10, name: "Patch", symbol: "patch" },
    { id: 7, name: "Puffs", symbol: "puff" },
    { id: 17, name: "Sachet", symbol: "sachet" },
    { id: 16, name: "Scoop", symbol: "scoop" },
    { id: 8, name: "Sprays", symbol: "spray" },
    { id: 15, name: "Suppository", symbol: "supp" },
    { id: 24, name: "Tablespoon", symbol: "tbsp" },
    { id: 13, name: "Tablet", symbol: "tab" },
    { id: 23, name: "Teaspoon", symbol: "tsp" },
    { id: 12, name: "Transdermal System", symbol: "TD system" }, // Common clinical shorthand
    { id: 6, name: "Units", symbol: "U" },
    { id: 19, name: "Vial", symbol: "vial" },
  ];

  //   const fetchInternalLabServices = async () => {
  //     try {
  //       // const response = await gets(
  //       //  endpoint: `/internallabservice/list/1/10`,
  //       // );
  //       let response = await gets({
  //         // endpoint: `patientlabreport/patient-report/${patientId?.id}/labtechnician/${userAuth?.resultList?.userId}`,
  //         endpoint: `/internallabservice/list/1/10`,

  //         // body: formData,
  //         // auth: false,
  //       });
  //       const data = response?.resultList;
  //       console.log(response);
  //       // Map the response to a format usable by React Select
  //       // const options = data?.map((med) => ({
  //       //   value: med?.id, // or med.code if you have it
  //       //   label: `${med?.productName} (${med.drugCategory}) - ${med.strength}`, // Adjust this based on your response structure
  //       // }));

  //       // setMedicationOptions(options); // Set options for the dropdown
  //       // setSelectedMedication(null); // Clear selection after fetching data
  //     } catch (error) {
  //       console.log(error);
  //     }
  //     // api/internallabservice/list/1/10
  //   };

  // Fetch Medications from API with Filter Query (Debounced)
  const fetchMedications = async (
    filterOn = "name",
    filterQuery = "a",
    pageNumber = 1,
    itemsPerPage = 10
  ) => {
    try {
      const response = await get(
        `/pharmacyinventory/filter-list/${filterOn}/${filterQuery}/${pageNumber}/${itemsPerPage}`
      );
      const data = response?.resultList;
      console.log(response);
      // Map the response to a format usable by React Select
      const options = data?.map((med) => ({
        value: med?.id, // or med.code if you have it
        label: `${med?.productName} (${med.drugCategory}) - ${med.strength}`, // Adjust this based on your response structure
      }));

      setMedicationOptions(options); // Set options for the dropdown
      // setSelectedMedication(null); // Clear selection after fetching data
    } catch (error) {
      console.log(error);
    }
  };

  const handleTranscript = (transcript) => {
    setCarePlan(carePlan + transcript);
  };

  const fetchPatientHMO = async () => {
    try {
      const response = await get(`/hmo/get-patient-hmo/${id}`);
      console.log(response.data);
      setHmo(response?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  // Function to update the suggestPayload
  const updateSuggestPayload = () => {
    const allMedications = [
      ...medications?.map((med) => med.name),
      ...otherMedications?.map((med) => med.name),
    ];
    if (allMedications.length === 0) {
      setSuggPayload({ medications: [] });
      return;
    } else {
      setSuggPayload({ medications: allMedications });
    }
  };

  // Update suggestPayload whenever medications or otherMedications change
  useEffect(() => {
    // updateSuggestPayload();
    // fetchInternalLabServices();
  }, [medications, otherMedications]);

  const addMedicationFromDropdown = () => {
    if (selectedMedication) {
      setMedications((prev) => [
        ...prev,
        {
          name: selectedMedication.label,
          pharmacyInventoryId: selectedMedication.value, // Save the medication ID (value) here
          quantity: "",
          frequency: "",
          duration: "",
        },
      ]);
      setSelectedMedication(null); // Clear selection after adding
    } else {
      toast.error("Please select a valid medication");
    }
  };

  const addOtherMedication = () => {
    if (newOtherMedication) {
      setOtherMedications((prev) => [
        ...prev,
        {
          name: newOtherMedication,
          quantity: 0,
          frequency: 0,
          duration: 0,
          dosage: "", // Add dosage field for other medications
        },
      ]);
      setNewOtherMedication("");
    } else {
      toast.error("Please enter the other medication name");
    }
  };

  const removeMedication = (index, type) => {
    if (type === "medications") {
      const updatedMedications = [...medications];
      updatedMedications.splice(index, 1);
      setMedications(updatedMedications);
    } else if (type === "otherMedications") {
      const updatedOtherMedications = [...otherMedications];
      updatedOtherMedications.splice(index, 1);
      setOtherMedications(updatedOtherMedications);
    }
  };

  const handleMedicationChange = (
    index,
    field,
    value,
    type = "medications"
  ) => {
    const updatedMedications = [
      ...(type === "medications" ? medications : otherMedications),
    ];

    let updatedValue = value;
    if (["duration", "quantity"].includes(field)) {
      updatedValue = parseInt(value, 10) || 0;
    }

    updatedMedications[index] = {
      ...updatedMedications[index],
      [field]: updatedValue,
    };

    if (type === "medications") {
      setMedications(updatedMedications);
    } else {
      setOtherMedications(updatedMedications);
    }
  };
  const addTreatment = async () => {
    // Basic validation
    if (medications.length === 0 && otherMedications.length === 0) {
      toast.error("Please add at least one medication");
      return;
    }

    console.log(medications);

    // Validate that all medications have required fields
    const invalidMedications = medications.filter(
      (med) =>
        !med.quantity ||
        !med.frequency ||
        !med.drugStrengthUnit ||
        !med.administrationFrequency ||
        !med.routeOfAdministration ||
        !med.duration
    );

    console.log(invalidMedications);

    const invalidOtherMedications = otherMedications.filter(
      (med) =>
        !med.quantity ||
        !med.frequency ||
        !med.drugStrengthUnit ||
        !med.administrationFrequency ||
        !med.routeOfAdministration ||
        !med.duration
    );

    if (invalidMedications.length > 0 || invalidOtherMedications.length > 0) {
      toast.error(
        "Please fill in all required fields for all medications (quantity, strength, unit, frequency, route, duration)"
      );
      return;
    }

    setLoading(true);

    // Prepare the medications payload according to the new schema
    const formattedMedications = medications?.map((med) => ({
      medicationId: med.id || 0, // Use prescription ID as medicationId
      pharmacyInventoryId: med.pharmacyInventoryId || 0,
      strength: med.frequency || "",
      drugStrengthUnit: +med.drugStrengthUnit || 0,
      quantity: +med.quantity || 0,
      administrationFrequency: +med.administrationFrequency || 0,
      routeOfAdministration: +med.routeOfAdministration || 0,
      duration: +med.duration || 0,
      dosage: med.dosage || "", // Include manual dosage input
    }));

    // Prepare the otherMedications payload according to the new schema
    const formattedOtherMedications = otherMedications?.map((med) => ({
      medicationId: 0, // Other medications don't have prescription ID
      pharmacyInventoryId: 0, // Other medications don't have inventory ID
      strength: med.frequency || "",
      drugStrengthUnit: +med.drugStrengthUnit || 0,
      quantity: +med.quantity || 0,
      administrationFrequency: +med.administrationFrequency || 0,
      routeOfAdministration: +med.routeOfAdministration || 0,
      duration: +med.duration || 0,
      dosage: med.dosage || "", // Include manual dosage input for other medications
    }));

    // Combine all medications into a single array
    const allMedications = [
      ...formattedMedications,
      ...formattedOtherMedications,
    ];

    // Construct the payload according to the new schema
    const payload = {
      medications: allMedications,
    };

    console.log("Payload for dosage details:", payload);

    if (createTreatment) {
      createTreatment && createTreatment(payload);
      setLoading(false);
      return;
    }

    try {
      // Using the new API endpoint structure
      const response = await put(
        `/patient/${data.patientId}/add-dosage-details-to-prescription/service-treatment/${data.id}`,
        payload,
        true
      );
      console.log(response);

      if (response) {
        toast.success("Medication dosage details updated successfully");

        // Clear the form
        setMedications([]);
        setOtherMedications([]);
        setSelectedMedication(null);
        setNewOtherMedication("");

        if (fetchData) {
          await fetchData();
        }
        closeModal();
      } else {
        toast.error("Error updating medication dosage details");
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Network error occurred while updating medication details");
    }

    setLoading(false);
  };

  // Debounced Search Function for Medications
  //   const debouncedFetchMedications = useCallback(
  //     debounce((query) => {
  //       fetchMedications("name", query); // Fetch medications based on typed query
  //     }, 300), // 300ms debounce
  //     []
  //   );

  //   // Handle input change in React Select's input field for searching medications
  //   const handleInputChange = (inputValue) => {
  //     debouncedFetchMedications(inputValue); // Trigger debounced API call
  //     // setSelectedMedication(inputValue);
  //     console.log(inputValue);
  //   };

  useEffect(() => {
    fetchTreatmentCategory();
    fetchPatientHMO();
    // fetchMedications();
  }, []);

  return (
    <div className="overlay">
      <RiCloseFill className="close-btn pointer" onClick={closeModal} />
      <div className="modal-box max-w-1400">
        <div className="p-40" style={{ backgroundColor: "#fafbfc" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #3C7E2D 0%, #4A9035 100%)",
              color: "white",
              padding: "20px",
              borderRadius: "8px",
              marginBottom: "24px",
              boxShadow: "0 4px 12px rgba(60, 126, 45, 0.2)",
            }}
          >
            <h3 className="bold-text" style={{ margin: 0, fontSize: "1.5rem" }}>
              Add Medication Dosage Details
            </h3>
            <p
              style={{ margin: "8px 0 0 0", opacity: 0.9, fontSize: "0.9rem" }}
            >
              Configure medication dosages and administration details for
              prescriptions
            </p>
          </div>

          {/* Treatment Category */}
          {/* <div
            className="w-100 m-t-20 flex"
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "16px",
            }}
          >
            <label
              htmlFor="category"
              className="label"
              style={{ fontWeight: "600", color: "#2c3e50" }}
            >
              🏥 Treatment Category
            </label>
            <select
              id="category"
              className="input-field"
              value={selectedCategoryId}
              onChange={(e) => setSelectedCategoryId(e.target.value)}
              style={{
                padding: "12px 16px",
                border: "2px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "0.9rem",
              }}
            >
              {treatmentCategories?.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div> */}

          {/* Admission Status */}
          {/* <div
            className="w-100 m-t-20 flex"
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "24px",
            }}
          >
            <label
              htmlFor="admission"
              className="label"
              style={{ fontWeight: "600", color: "#2c3e50" }}
            >
              🏠 Admission Status
            </label>
            <select
              id="admission"
              className="input-field"
              value={admissionStatus}
              onChange={(e) => setAdmissionStatus(e.target.value)}
              style={{
                padding: "12px 16px",
                border: "2px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "0.9rem",
              }}
            >
              <option value="Admitted">To Be Admitted</option>
              <option value="Not To Be Admitted">Not To Be Admitted</option>
            </select>
          </div> */}

          {/* Medications from API */}
          {/* <div
            className="m-t-20"
            style={{
              background: "white",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "20px",
            }}
          >
            <h4
              style={{
                marginBottom: "16px",
                color: "#2c3e50",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              Add Medication from Inventory
            </h4>
            <Select
              options={medicationOptions} // Use fetched medication options
              value={selectedMedication}
              onChange={setSelectedMedication}
              placeholder="Search and select a medication..."
              onInputChange={handleInputChange} // Trigger fetch on input change
              isClearable
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "2px solid #e1e5e9",
                  borderRadius: "8px",
                  padding: "4px",
                  boxShadow: state.isFocused
                    ? "0 0 0 3px rgba(60, 126, 45, 0.1)"
                    : "none",
                  borderColor: state.isFocused ? "#3C7E2D" : "#e1e5e9",
                  "&:hover": {
                    borderColor: "#3C7E2D",
                  },
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "#3C7E2D"
                    : state.isFocused
                    ? "#f8fffe"
                    : "white",
                  color: state.isSelected ? "white" : "#2c3e50",
                  padding: "12px 16px",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  color: "#6c757d",
                  fontSize: "0.9rem",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#2c3e50",
                }),
              }}
            />
            <button
              className="btn m-t-10"
              onClick={addMedicationFromDropdown}
              style={{
                background: selectedMedication
                  ? "linear-gradient(135deg, #3C7E2D 0%, #4A9035 100%)"
                  : "#cccccc",
                cursor: selectedMedication ? "pointer" : "not-allowed",
              }}
            >
              Add Selected Medication
            </button>
          </div> */}
          {/* Doctor's Prescription Table */}
          {data?.prescriptions && data.prescriptions.length > 0 && (
            <div
              className="m-t-20"
              style={{
                background: "white",
                padding: "24px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: "#2c3e50",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {/* Doctor's Prescription Details */}
                Doctor's Prescription Details ({data.prescriptions.length})
              </h4>
              <table className="bordered-table-2 m-t-10">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Medication</th>{" "}
                    {/* Pharmacy inventory medication name */}
                    <th>Dosage</th> {/* Doctor prescribed dosage */}
                    <th>Strength</th> {/* Doctor prescribed strength */}
                    <th>Unit</th> {/* Doctor prescribed unit */}
                    <th>Quantity</th> {/* Doctor prescribed quantity */}
                    <th>Frequency</th> {/* Doctor prescribed frequency */}
                    <th>Route</th> {/* Doctor prescribed route */}
                    <th>Duration</th> {/* Doctor prescribed duration */}
                    <th>Comments</th> {/* Prescription comments */}
                    <th>Status</th> {/* Dispensed status */}
                  </tr>
                </thead>
                <tbody>
                  {data.prescriptions?.map((prescription, index) => (
                    <tr key={prescription.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        <div>
                          <strong>
                            {prescription.pharmacyInventory?.productName ||
                              "Unknown Medication"}
                          </strong>
                          <div
                            style={{
                              fontSize: "0.8rem",
                              color: "#666",
                              marginTop: "4px",
                            }}
                          >
                            Status:{" "}
                            {prescription.pharmacyInventory?.status || "N/A"}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            fontSize: "0.9rem",
                            color: "#007bff",
                            fontWeight: "500",
                          }}
                        >
                          {prescription.doctorPrescription?.dosage || "N/A"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription?.strength ||
                            "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription?.drugStrengthUnit ||
                            "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription?.quantity ||
                            "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription
                            ?.administrationFrequency || "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription
                            ?.routeOfAdministration || "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: "0.9rem" }}>
                          {prescription.doctorPrescription?.duration ||
                            "Not specified"}
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            fontSize: "0.8rem",
                            maxWidth: "200px",
                            wordWrap: "break-word",
                          }}
                        >
                          {prescription.comment || "No comments"}
                        </div>
                      </td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "0.75rem",
                            fontWeight: "500",
                            backgroundColor: prescription.isDispensed
                              ? "#d4edda"
                              : "#f8d7da",
                            color: prescription.isDispensed
                              ? "#155724"
                              : "#721c24",
                            border: prescription.isDispensed
                              ? "1px solid #c3e6cb"
                              : "1px solid #f5c6cb",
                          }}
                        >
                          {prescription.isDispensed ? "Dispensed" : "Pending"}
                        </span>
                        {prescription.isDispensed &&
                          prescription.dispensedDate && (
                            <div
                              style={{
                                fontSize: "0.7rem",
                                color: "#666",
                                marginTop: "4px",
                              }}
                            >
                              {new Date(
                                prescription.dispensedDate
                              ).toLocaleDateString()}
                            </div>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Prescription Comments Section */}
          <div
            className="m-t-20"
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "20px",
            }}
          >
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* Prescription comments input section */}
              Prescription Comments
            </h4>
            <textarea
              className="input-field"
              value={data?.prescriptions[0]?.comment || ""}
              onChange={(e) => setCarePlan(e.target.value)}
              placeholder="Enter additional prescription details or comments..."
              style={{
                padding: "12px 16px",
                border: "2px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "0.9rem",
                width: "100%",
                minHeight: "100px",
                resize: "vertical",
              }}
            />
          </div>
          {/* Table for Medications */}
          {medications.length > 0 && (
            <div
              className="m-t-20"
              style={{
                background: "white",
                padding: "24px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: "#2c3e50",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                Prescription Medications ({medications.length})
              </h4>
              <table className="bordered-table-2 m-t-10">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Medication</th>
                    <th>Dosage*</th>
                    <th>Strength *</th>
                    <th>Unit *</th>
                    <th>Frequency *</th>
                    {/* <th>Dosage</th> */}
                    <th>Duration *</th>
                    <th>Route *</th>
                    <th>Quantity *</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {medications?.map((med, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div>
                          <strong>{med.name}</strong>
                          {med.id && (
                            <div
                              style={{
                                fontSize: "0.8rem",
                                color: "#666",
                                marginTop: "4px",
                              }}
                            >
                              Prescription ID: {med.id}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        {/* Dosage input field - allows manual entry instead of calculated display */}
                        <input
                          type="text"
                          className="input-field-table"
                          value={med.dosage || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "dosage",
                              e.target.value,
                              "medications"
                            )
                          }
                          placeholder="Dosage"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          className="input-field-table"
                          value={med.frequency || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "frequency",
                              e.target.value,
                              "medications"
                            )
                          }
                          placeholder="e.g., 500mg"
                        />
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.drugStrengthUnit || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "drugStrengthUnit",
                              e.target.value,
                              "medications"
                            )
                          }
                        >
                          <option value="">--Select Unit--</option>
                          {drugMeasurementUnits?.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.name}
                              {unit.symbol ? ` (${unit.symbol})` : ""}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.administrationFrequency || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "administrationFrequency",
                              e.target.value,
                              "medications"
                            )
                          }
                        >
                          <option value="">--Select Frequency--</option>
                          {administrationFrequencies.map((freq) => (
                            <option key={freq.id} value={freq.id}>
                              {freq.name}
                              {freq.abbreviation
                                ? ` (${freq.abbreviation})`
                                : ""}
                            </option>
                          ))}
                        </select>
                      </td>

                      <td>
                        <input
                          type="number"
                          className="input-field-table"
                          value={med.duration}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "duration",
                              e.target.value,
                              "medications"
                            )
                          }
                          placeholder="Days"
                        />
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.routeOfAdministration || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "routeOfAdministration",
                              e.target.value,
                              "medications"
                            )
                          }
                        >
                          <option value="">--Select Route--</option>
                          {routesOfAdministration.map((route) => (
                            <option key={route.id} value={route.id}>
                              {route.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="number"
                          className="input-field-table"
                          value={med.quantity}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "quantity",
                              e.target.value,
                              "medications"
                            )
                          }
                          placeholder="Enter quantity"
                        />
                      </td>
                      <td>
                        <BsTrash
                          className="text-red pointer"
                          onClick={() => removeMedication(index, "medications")}
                          style={{
                            fontSize: "1.1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Input for adding Other Medications */}
          <div
            className="m-t-20"
            style={{
              padding: "20px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e1e5e9",
            }}
          >
            <h4 style={{ marginBottom: "16px", color: "#2c3e50" }}>
              Add Other Medication
            </h4>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <input
                type="text"
                placeholder="Enter medication name not in inventory..."
                value={newOtherMedication}
                onChange={(e) => setNewOtherMedication(e.target.value)}
                style={{
                  padding: "12px 16px",
                  border: "2px solid #e1e5e9",
                  borderRadius: "6px",
                  fontSize: "0.9rem",
                  flex: "1",
                  minWidth: "250px",
                  transition: "all 0.3s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#3C7E2D";
                  e.target.style.boxShadow = "0 0 0 3px rgba(60, 126, 45, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e1e5e9";
                  e.target.style.boxShadow = "none";
                }}
              />
              <button
                className="btn"
                onClick={addOtherMedication}
                style={{
                  background: newOtherMedication
                    ? "linear-gradient(135deg, #3C7E2D 0%, #4A9035 100%)"
                    : "#cccccc",
                  cursor: newOtherMedication ? "pointer" : "not-allowed",
                  whiteSpace: "nowrap",
                }}
              >
                Add Other Medication
              </button>
            </div>
          </div>

          {otherMedications.length > 0 && (
            <div
              className="m-t-10"
              style={{
                background: "white",
                padding: "24px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: "20px",
              }}
            >
              <h4
                style={{
                  color: "#2c3e50",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                🏥 Other Medications ({otherMedications.length})
              </h4>
              <table className="bordered-table-2 m-t-10">
                <thead>
                  <tr>
                    <th>#</th>
                    <th> Medication</th>
                    <th> Quantity</th>
                    <th> Strength</th>
                    <th> Unit</th>
                    <th> Frequency</th>
                    <th> Dosage</th> {/* Added dosage column for consistency */}
                    <th> Duration</th>
                    <th> Route</th>
                    <th> Action</th>
                  </tr>
                </thead>
                <tbody>
                  {otherMedications?.map((med, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{med.name}</td>
                      <td>
                        <input
                          type="number"
                          className="input-field-table"
                          value={med.quantity}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "quantity",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                          placeholder="Qty"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-field-table"
                          value={med.frequency || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "frequency",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                          placeholder="e.g., 500mg"
                        />
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.drugStrengthUnit || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "drugStrengthUnit",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                        >
                          <option value="">--Select Unit--</option>
                          {drugMeasurementUnits?.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.name}
                              {unit.symbol ? ` (${unit.symbol})` : ""}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.administrationFrequency || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "administrationFrequency",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                        >
                          <option value="">--Select Frequency--</option>
                          {administrationFrequencies?.map((freq) => (
                            <option key={freq.id} value={freq.id}>
                              {freq.name}
                              {freq.abbreviation
                                ? ` (${freq.abbreviation})`
                                : ""}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        {/* Dosage input field for other medications */}
                        <input
                          type="text"
                          className="input-field-table"
                          value={med.dosage || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "dosage",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                          placeholder="e.g., 500mg BID"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="input-field-table"
                          value={med.duration}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "duration",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                          placeholder="Days"
                        />
                      </td>
                      <td>
                        <select
                          className="input-field-table"
                          value={med.routeOfAdministration || ""}
                          onChange={(e) =>
                            handleMedicationChange(
                              index,
                              "routeOfAdministration",
                              e.target.value,
                              "otherMedications"
                            )
                          }
                        >
                          <option value="">--Select Route--</option>
                          {routesOfAdministration.map((route) => (
                            <option key={route.id} value={route.id}>
                              {route.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <BsTrash
                          className="text-red pointer"
                          onClick={() =>
                            removeMedication(index, "otherMedications")
                          }
                          style={{
                            fontSize: "1.1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <button
            className="btn m-t-20 w-100"
            onClick={addTreatment}
            disabled={loading}
            style={{
              background: loading
                ? "#cccccc"
                : "linear-gradient(135deg, #3C7E2D 0%, #4A9035 100%)",
              fontSize: "1.1rem",
              padding: "16px 24px",
              fontWeight: "600",
              borderRadius: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: loading ? "none" : "0 4px 12px rgba(60, 126, 45, 0.3)",
              marginTop: "32px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(60, 126, 45, 0.4)";
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 12px rgba(60, 126, 45, 0.3)";
              }
            }}
          >
            {loading
              ? "Updating Prescription Details..."
              : medications.some((med) => med.id)
              ? " Update Prescription Dosage Details"
              : " Add Medication Dosage Details"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateModalToAccount;
